{
  "text-embedding-3-small": {
    "modelName": "text-embedding-3-small",
    "currency": "USD",
    "inputPricePerMillion": 0.02
  },
  "text-embedding-3-large": {
    "modelName": "text-embedding-3-large",
    "currency": "USD",
    "inputPricePerMillion": 0.13
  },
  "text-embedding-ada-002": {
    "modelName": "text-embedding-ada-002",
    "currency": "USD",
    "inputPricePerMillion": 0.1
  }
}
